// extracted by mini-css-extract-plugin
export var tosLink = "_dx-0";